import React from 'react';
import Typography from '@mui/material/Typography';

const EmbargoedColumns: React.FC = () => {
  return (
    <>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>IP Address</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Country</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Country Code</Typography>
      </div>
      <div className='hb-title-col'>
        <Typography className='hb-title-typo'>Embargo Status</Typography>
      </div>
    </>
  );
};

export default EmbargoedColumns;
